import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { http } from "../lib/api";
import { LogoMark } from "../components/Logo";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const done = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const sid = new URLSearchParams(location.hash.slice(1)).get("session_id");
    window.history.replaceState(null, "", window.location.pathname);
    http.post("/auth/session", { session_id: sid })
      .then((r) => {
        toast.success("Bem-vindo, administrador");
        navigate("/admin", { replace: true, state: { user: r.data } });
      })
      .catch((e) => {
        const msg = e.response?.data?.detail || "Falha no login";
        setError(msg);
        toast.error(msg);
        navigate("/admin/login", { replace: true, state: { error: msg } });
      });
  }, [location.hash, navigate]);

  return (
    <div className="flex min-h-screen items-center justify-center" data-testid="auth-callback">
      <div className="animate-pulse"><LogoMark size={56} /></div>
      {error && <p className="sr-only">{error}</p>}
    </div>
  );
}
